export const getScrollParams = (search?: string) => {
    const searchParams = new URLSearchParams(
        search ?? window?.top?.location.search ?? '',
    );
    const scrollToFirstPendingTag = !!searchParams.get(
        'scrollToFirstPendingTag',
    );
    const scrollToTagID = Number(searchParams.get('scrollToTagID'));
    const scrollToProductID = Number(searchParams.get('scrollToProductID'));
    const scrollToImageID = Number(searchParams.get('scrollToImageID'));
    /**
     * Stored file of the image to scroll to. Links built from the ImageLabel
     * search index carry this alongside the id: the index holds its own
     * LibraryImage rows, so its ids are absent from the page-builder tree and
     * the id alone never matches. See `imageSourceFile`.
     */
    const scrollToImageFile = (
        searchParams.get('scrollToImageFile') ?? ''
    ).toLowerCase();

    return {
        scrollToFirstPendingTag,
        scrollToTagID,
        scrollToProductID,
        scrollToImageID,
        scrollToImageFile,
    };
};
